import { DEFAULT_MEDIA_ROOT, normalizePath } from '../../_utils';

export const WELCOME_MEDIA_FOLDER_KEY = '__welcome__';

export const buildYoloSessionMediaFolderPath = (sessionId: string) => `${DEFAULT_MEDIA_ROOT}/sess-${sessionId}`;

export const getParentFolderPath = (path: string) => normalizePath(path).split('/').slice(0, -1).join('/');

export const getFolderName = (path: string) => normalizePath(path).split('/').filter(Boolean).pop() ?? '';

export const normalizeFilePath = (path: string) => path.trim().replace(/^\.?\//, '');
